import {z} from 'zod';

import {LogActionsEnum} from '../../page/main/reviews/review-logs/review-log-type';
import {LangKeyType} from '../../provider/locale/translation/type';

/** Status codes in review log `type: abuse`, `action: updated` (BE / DEV-19350). */
const abuseLogStatusSchema = z.enum([
    'sent',
    'accepted',
    'declined',
    'error',
    'not_sent',
    'auto_sent',
    'will_be_checked_by_ai',
    'default',
    'review_not_found',
]);

type AbuseLogStatusType = z.infer<typeof abuseLogStatusSchema>;

const reviewAbuseLogStatusToLocaleMap: Record<AbuseLogStatusType, LangKeyType> = {
    sent: 'REVIEW__ABUSE_STATUS__SENT',
    accepted: 'REVIEW__ABUSE_STATUS__ACCEPTED',
    declined: 'REVIEW__ABUSE_STATUS__DECLINED',
    error: 'REVIEWS__REVIEW_ABUSE_LOG_STATUS__ERROR',
    not_sent: 'REVIEWS__REVIEW_ABUSE_LOG_STATUS__NOT_SENT',
    auto_sent: 'REVIEW__ABUSE_STATUS_DESCRIPTION__AUTO_SENT',
    will_be_checked_by_ai: 'REVIEW__ABUSE_STATUS_DESCRIPTION__CHECKED__TITLE',
    default: 'REVIEW__ABUSE_STATUS__SENT',
    review_not_found: 'REVIEWS__REVIEW_ABUSE_LOG_STATUS__REVIEW_NOT_FOUND',
};

const abuseLogAutoCreateOldValueSchema = z.literal('auto');
const abuseLogStatusChangeActionSchema = z.literal(LogActionsEnum.Updated);

export function getAbuseLogStatusLocaleKey(status: string): LangKeyType | null {
    const parsed = abuseLogStatusSchema.safeParse(status);

    if (!parsed.success) {
        return null;
    }

    return reviewAbuseLogStatusToLocaleMap[parsed.data];
}

export function isAutoAbuseCreate(oldValue: string | null | undefined): boolean {
    return abuseLogAutoCreateOldValueSchema.safeParse(oldValue).success;
}

export function isAbuseStatusChangeLog(action: string): boolean {
    return abuseLogStatusChangeActionSchema.safeParse(action).success;
}
